export const STALE_TIME_PRESETS = {
  NONE: 0,
  S: 10_000,
  M: 30_000,
  L: 60_000,
  XL: 300_000,
  XXL: 600_000,
  FOREVER: Infinity,
} as const;

export type StaleTimePreset = keyof typeof STALE_TIME_PRESETS;

export function resolveStaleTime(
  preset: StaleTimePreset | undefined,
): number | undefined {
  if (!preset) {
    return undefined;
  }
  return STALE_TIME_PRESETS[preset];
}
